import { useState, useRef, useEffect, useCallback } from 'react';

const REPEAT_DELAY_MS = 5000;

/**
 * Plays a CSS jiggle affordance on mount, then repeats every REPEAT_DELAY_MS
 * until the element is first dragged. Once discovered, jiggling stops permanently.
 */
export function useJiggle(isDragging: boolean) {
  const [jiggling, setJiggling] = useState(true);
  const [discovered, setDiscovered] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (isDragging && !discovered) {
      setDiscovered(true);
      if (timerRef.current) clearTimeout(timerRef.current);
      setJiggling(false);
    }
  }, [isDragging, discovered]);

  useEffect(() => () => { if (timerRef.current) clearTimeout(timerRef.current); }, []);

  const onAnimationEnd = useCallback(() => {
    setJiggling(false);
    if (!discovered) {
      timerRef.current = setTimeout(() => setJiggling(true), REPEAT_DELAY_MS);
    }
  }, [discovered]);

  return { jiggling, onAnimationEnd };
}
